export function sdkMessageFormatter(sdkName) {
    return (logLevel, ...messages) => {
        const bgColor = logLevel === 'info' ? '#FFC244' : '#FF0000';
        return [
            `%c${sdkName}`,
            `font-weight:bold; background-color:${bgColor}; color:#1D1D1D; padding:3px 6px; border-radius:10px`,
            ...messages,
        ];
    };
}
//# sourceMappingURL=sdk-message-formatter.js.map